module.exports = __webpack_public_path__ + "img/info.6c159433.svg";